import React from 'react';
import './BlindsCategory.css';
import { Link } from 'react-router-dom';


// Updated array (removed 5th & 6th items, renamed images)
const blinds = [
  { title: 'Meliso Blinds', desc: 'Innovative and Unique Blinds', img: '/Assets/CategoryImages/c1.webp', link: '/products/meliso-blinds' },
  { title: 'Colby Blinds', desc: 'Most Energy Efficient Blinds', img: '/Assets/CategoryImages/c2.webp', link: '/products/colby-blinds' },
  { title: 'Special Solution', desc: 'Solution For Challenging Architectural Design Window', img: '/Assets/CategoryImages/c3.webp', link: '/special-solutions' },
  { title: 'Aric Blinds', desc: 'Innovative and Unique Blinds', img: '/Assets/CategoryImages/c4.webp', link: '/products/aric-blinds' },
  // Removed Colby and Printed blinds (indexes 4 and 5)
  { title: 'Skylight Blinds', desc: 'Enjoy Privacy and an open View at the Same Time', img: '/Assets/CategoryImages/c5.webp', link: '/products/skylight-blinds' },
  { title: "World's Largest Range of Blinds", desc: '15 Types of Blinds', img: '/Assets/CategoryImages/c6.webp', link: '/products' },
  { title: 'Blinds with Curtain', desc: 'Blinds with Curtain', img: '/Assets/CategoryImages/c7.webp', link: '/products/roman-blinds' },
  { title: 'Automation', desc: 'Automation in blinds improves function, comfort, pleasure and adds value in life', img: '/Assets/CategoryImages/c8.webp', link: '/automation' },
];

const BlindsCategory = () => {
  const paired = [];
  for (let i = 0; i < blinds.length; i += 2) {
    paired.push(blinds.slice(i, i + 2));
  }

  return (
    <section className="CategorySection">
      <div className="blinds-section">
        <h2 className="blinds-title">Customized Window Blinds</h2>
        <p className="blinds-subtitle">
          Explore how Callistus Blinds window treatments transform the light into your home or offices,
          elevating everyday living and add beauty to the mood of your unique space.
        </p>

        <div className="blinds-wrapper">
          {paired.map((pair, index) => {
            const rowClass = `row-${(index % 5) + 1}`;
            return (
              <div className={`blinds-row ${rowClass}`} key={index}>
                {pair.map((item, subIndex) => (
                  <Link to={item.link} className={`blinds-card card-${subIndex + 1}`} key={subIndex}>
                    <div className="blinds-image-wrapper">
                      <img src={item.img} alt={item.title} className="blinds-image" />
                    </div>
                    <div className="blinds-text">
                      <div className="blinds-label">{item.title}</div>
                      <div className="blinds-subtext">{item.desc}</div>
                    </div>
                  </Link>
                ))}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default BlindsCategory;
